export default "__VITE_ASSET__CTtGZjEs__"